export default "__VITE_ASSET__CRmDlPrg__"